<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page
            title="Bayaran Balik Bantuan - Laporan - Senarai Melebihi Tempoh"
        >
            <w-form ref="dform" @validate="search">
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input v-model="cari.no_rujukan"
                            >No. Rujukan Subsidiari</w-input
                        >
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Skim Bantuan"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_skim'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_skim_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input v-model="cari.nama_id">No. Id/Nama</w-input>
                    </div>

                    <div class="xs6 mr5">
                        <z-lookup
                            label="Status"
                            name="status"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_status'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_status_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <!-- <div class="xs6 mr5">
                        <z-lookup
                            label="Perihal Tunggakan"
                            name="perihal"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_perihal'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_perihal_id"
                        />
                    </div> -->
                    <div class="xs6 mr5">
                        <w-input
                            v-model="cari.tunggakan_dari"
                            required
                            label="Tempoh Tunggakan"
                            type="date"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <w-input
                            v-model="cari.tunggakan_hingga"
                            required
                            label="Tempoh Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>

                    <w-button
                        class="ml1"
                        @click="$refs.dform.validate()"
                        :loading="cari.loading"
                    >
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br />
            <center v-if="cari.loading">
                <w-progress class="ma1" circle></w-progress>
            </center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>BIL.</td>
                                <td style="min-width: 110px">TARIKH DOKUMEN</td>
                                <td>NO. RUJUKAN SUBSIDIARI</td>
                                <td>NAMA</td>
                                <td>NO. KAD PENGENALAN</td>
                                <td>SKIM BANTUAN</td>
                                <td>TEMPOH TUNGGAKAN</td>
                                <td>JUMLAH TUNGGAKAN (RM)</td>
                                <td>AMAUN TELAH DIKUTIP (RM)</td>
                                <td>BAKI</td>
                                <td>TARIKH SURAT PERINGATAN</td>
                                <td>BILANGAN HARI TERTUNGGAK</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr
                                    v-for="(dt, index) in filteredItems"
                                    :key="index"
                                >
                                    <td style="text-align: center">
                                        {{ index + 1 }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.tarikh_laporan }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.no_rujukan }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.nama }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.no_id }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.skim_keterangan }}
                                    </td>
                                    <td style="text-align: right">
                                        {{ dt.tempoh_hingga }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.amaun_tunggakan }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.amaun_kredit }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.amaun_baki }}
                                    </td>
                                    <td style="text-align: center">
                                        {{ dt.tarikh_surat }}
                                    </td>
                                    <td style="text-align: center">
                                        <button
                                            type="button"
                                            :class="{
                                                'btn-hijau':
                                                    dt.tempoh_surat <= 30,
                                                'btn-kuning':
                                                    dt.tempoh_surat > 30 &&
                                                    dt.tempoh_surat < 44,
                                                'btn-merah':
                                                    dt.tempoh_surat >= 58,
                                            }"
                                            style="padding: 10px 30px"
                                        >
                                            {{ dt.tempoh_surat }}
                                        </button>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="9" style="text-align: center">
                                        Tiada Rekod
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <!-- <tfoot>
                            <tr>
                                <td colspan="6"><b>JUMLAH (RM)</b></td>
                                <td style="text-align: right">
                                    <b>{{ table.total_amaun }}</b>
                                </td>
                                <td colspan="3"><b>&nbsp;</b></td>
                            </tr>
                        </tfoot> -->
                    </table>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "tuntutan_bantuan",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Bantuan Am", route: "/tuntutan_bantuan" },
                {
                    label: "Laporan ",
                    route: "/tuntutan_bantuan/tempoh",
                },
            ],
            cari: {
                no_rujukan: "",
                nama_id: "",
                profil_id: "",
                lkp_tuntutan_bantuan_skim_id: "",
                // lkp_tuntutan_bantuan_perihal_id: "",
                lkp_tuntutan_bantuan_status_id: "",
                tunggakan_dari: "",
                tunggakan_hingga: "",
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true;
            this.$inertia.visit(
                window.route("bantuan.tempoh") +
                    "?no_rujukan=" +
                    this.cari.no_rujukan +
                    "&nama_id=" +
                    this.cari.nama_id +
                    "&lkp_tuntutan_bantuan_skim_id=" +
                    this.cari.lkp_tuntutan_bantuan_skim_id +
                    // "&lkp_tuntutan_bantuan_perihal_id=" +
                    // this.cari.lkp_tuntutan_bantuan_perihal_id +
                    "&lkp_tuntutan_bantuan_status_id=" +
                    this.cari.lkp_tuntutan_bantuan_status_id +
                    "&tunggakan_dari=" +
                    this.cari.tunggakan_dari +
                    "&tunggakan_hingga=" +
                    this.cari.tunggakan_hingga,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                no_rujukan: "",
                nama_id: "",
                lkp_tuntutan_bantuan_skim_id: "",
                // lkp_tuntutan_bantuan_perihal_id: "",
                lkp_tuntutan_bantuan_status_id: "",
                tunggakan_dari: "",
                tunggakan_hingga: "",
            };
            this.search();
        },
    },
    computed: {
        filteredItems() {
            return this.table.items.filter((item) => item.tempoh_surat > 30);
        },
    },

    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        // console.log(items);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.no_rujukan == "undefined") {
            this.cari.no_rujukan = "";
        }
        if (this.cari.profil_id == "undefined") {
            this.cari.profil_id = "";
        }
        if (this.cari.lkp_tuntutan_bantuan_skim_id == "undefined") {
            this.cari.lkp_tuntutan_bantuan_skim_id = "";
        }
        // if (this.cari.lkp_tuntutan_bantuan_perihal_id == "undefined") {
        //     this.cari.lkp_tuntutan_bantuan_perihal_id = "";
        // }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
        if (this.cari.lkp_tuntutan_bantuan_status_id == "undefined") {
            this.cari.lkp_tuntutan_bantuan_status_id = "";
        }
        if (this.cari.tunggakan_dari == "undefined") {
            this.cari.tunggakan_dari = "";
        }
        if (this.cari.tunggakan_hingga == "undefined") {
            this.cari.tunggakan_hingga = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}

.btn-hijau {
    border-radius: 4px;
    background-color: #4caf50; /* Green */
    border: none;
    color: white;
    padding: 4px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-kuning {
    border-radius: 4px;
    background-color: #ffc300; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}

.btn-merah {
    border-radius: 4px;
    background-color: #c70039; /* Green */
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    margin: 2px 1px;
    font-weight: 550;
}
</style>
